(function () {
  // Create modal HTML
  function createModal() {
    var existing = document.getElementById('sfm-modal');
    if (existing) return existing;

    var el = document.createElement('div');
    el.id = 'sfm-modal';
    el.style.cssText = 'display:none;position:fixed;top:0;left:0;right:0;bottom:0;z-index:99999;align-items:center;justify-content:center;flex-direction:row;';

    el.innerHTML = `
      <div id="sfm-overlay" style="position:fixed;inset:0;background:rgba(0,0,0,0.6);"></div>
      <div id="sfm-inner" style="position:relative;display:flex;border-radius:14px;overflow:hidden;box-shadow:0 24px 60px rgba(0,0,0,0.5);z-index:1;margin:auto;">
        
        <!-- Video side -->
        <div id="sfm-video-side" style="flex:0 0 auto;background:#000;position:relative;display:flex;align-items:center;justify-content:center;">
          <span id="sfm-counter" style="position:absolute;top:14px;left:14px;background:rgba(0,0,0,0.6);color:#fff;padding:5px 12px;border-radius:999px;font-size:13px;font-weight:600;z-index:5;">1 / 1</span>
          <button id="sfm-close" style="position:absolute;top:14px;right:14px;width:34px;height:34px;border-radius:50%;background:rgba(0,0,0,0.6);border:none;color:#fff;font-size:18px;cursor:pointer;z-index:5;display:flex;align-items:center;justify-content:center;">✕</button>
          <button id="sfm-prev" style="position:absolute;left:12px;top:50%;transform:translateY(-50%);width:38px;height:38px;border-radius:50%;background:rgba(0,0,0,0.6);border:none;color:#fff;font-size:24px;cursor:pointer;z-index:5;display:flex;align-items:center;justify-content:center;">‹</button>
          <button id="sfm-next" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);width:38px;height:38px;border-radius:50%;background:rgba(0,0,0,0.6);border:none;color:#fff;font-size:24px;cursor:pointer;z-index:5;display:flex;align-items:center;justify-content:center;">›</button>
          <video id="sfm-video" playsinline controls style="width:100%;height:100%;object-fit:contain;display:block;background:#000;"></video>
        </div>

        <!-- Info side -->
        <div id="sfm-info-side" style="background:#fff;display:flex;flex-direction:column;overflow-y:auto;">
          <img id="sfm-img" src="" alt="" style="border-radius:8px;border:1px solid #e8e8e8;object-fit:contain;padding:4px;background:#f5f5f5;">
          <div id="sfm-name" style="font-size:14px;font-weight:700;color:#111;line-height:1.4;margin-bottom:8px;"></div>
          <span id="sfm-compare" style="font-size:12px;color:#999;text-decoration:line-through;display:none;margin-bottom:2px;"></span>
          <span id="sfm-price" style="font-size:16px;font-weight:700;color:#111;display:block;margin-bottom:16px;"></span>
          <button id="sfm-atc" style="width:100%;height:46px;background:#001f5b;color:#fff;border:none;border-radius:6px;font-size:14px;font-weight:600;cursor:pointer;margin-top:auto;">Add to Cart</button>
        </div>
      </div>
    `;

    document.body.appendChild(el);

    // Apply responsive layout
    applyResponsiveLayout(el);
    window.addEventListener('resize', function() { applyResponsiveLayout(el); });

    return el;
  }

  function applyResponsiveLayout(el) {
    var isMobile = window.innerWidth <= 768;
    var inner = el.querySelector('#sfm-inner');
    var videoSide = el.querySelector('#sfm-video-side');
    var infoSide = el.querySelector('#sfm-info-side');
    var video = el.querySelector('#sfm-video');
    var img = el.querySelector('#sfm-img');

    if (isMobile) {
      // Mobile: vertical stack, full screen
      inner.style.cssText = 'position:relative;display:flex;flex-direction:column;width:100vw;max-width:100vw;height:100dvh;max-height:100dvh;border-radius:0;overflow:hidden;box-shadow:none;z-index:1;margin:0;';
      videoSide.style.cssText = 'flex:1 1 auto;background:#000;position:relative;display:flex;align-items:center;justify-content:center;min-height:0;overflow:hidden;';
      video.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;background:#000;';
      infoSide.style.cssText = 'flex:0 0 auto;background:#fff;display:flex;flex-direction:row;align-items:center;padding:12px 14px;gap:12px;overflow:hidden;min-height:80px;max-height:100px;';
      img.style.cssText = 'width:56px;height:56px;flex-shrink:0;border-radius:8px;border:1px solid #e8e8e8;object-fit:contain;padding:3px;background:#f5f5f5;';

      // Rearrange info panel for mobile horizontal layout
      var name = el.querySelector('#sfm-name');
      var price = el.querySelector('#sfm-price');
      var compare = el.querySelector('#sfm-compare');
      var atc = el.querySelector('#sfm-atc');

      name.style.cssText = 'font-size:12px;font-weight:600;color:#111;line-height:1.3;margin:0;flex:1;min-width:0;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;';
      compare.style.cssText = 'font-size:11px;color:#999;text-decoration:line-through;display:none;';
      price.style.cssText = 'font-size:14px;font-weight:700;color:#111;display:block;margin:0;white-space:nowrap;';
      atc.style.cssText = 'flex-shrink:0;height:38px;padding:0 14px;background:#001f5b;color:#fff;border:none;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;';

      // Wrap text+price+button in a flex column
      var textWrap = el.querySelector('#sfm-text-wrap');
      if (!textWrap) {
        textWrap = document.createElement('div');
        textWrap.id = 'sfm-text-wrap';
        textWrap.style.cssText = 'flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;';
        infoSide.insertBefore(textWrap, name);
        textWrap.appendChild(name);
        textWrap.appendChild(compare);
        textWrap.appendChild(price);
      }

    } else {
      // Desktop: side by side
      inner.style.cssText = 'position:relative;display:flex;flex-direction:row;width:fit-content;max-width:90vw;max-height:88vh;border-radius:14px;overflow:hidden;box-shadow:0 24px 60px rgba(0,0,0,0.5);z-index:1;margin:auto;';
      videoSide.style.cssText = 'flex:0 0 auto;width:360px;background:#000;position:relative;display:flex;align-items:center;justify-content:center;min-height:500px;';
      video.style.cssText = 'width:100%;height:100%;max-height:88vh;object-fit:contain;display:block;background:#000;aspect-ratio:9/16;';
      infoSide.style.cssText = 'width:280px;flex-shrink:0;background:#fff;display:flex;flex-direction:column;padding:20px;overflow-y:auto;';
      img.style.cssText = 'width:72px;height:72px;border-radius:8px;border:1px solid #e8e8e8;object-fit:contain;padding:4px;background:#f5f5f5;margin-bottom:12px;';

      var name = el.querySelector('#sfm-name');
      var price = el.querySelector('#sfm-price');
      var compare = el.querySelector('#sfm-compare');
      var atc = el.querySelector('#sfm-atc');

      name.style.cssText = 'font-size:14px;font-weight:700;color:#111;line-height:1.4;margin-bottom:8px;';
      price.style.cssText = 'font-size:16px;font-weight:700;color:#111;display:block;margin-bottom:16px;';
      atc.style.cssText = 'width:100%;height:46px;background:#001f5b;color:#fff;border:none;border-radius:6px;font-size:14px;font-weight:600;cursor:pointer;margin-top:auto;';
    }
  }

  var modal, items = [], currentIndex = 0;

  function openModal(allItems, index) {
    if (!modal) modal = createModal();
    items = allItems;
    currentIndex = index;
    modal.style.display = 'flex';
    modal.style.alignItems = 'center';
    modal.style.justifyContent = 'center';
    document.body.style.overflow = 'hidden';
    // Re-apply responsive layout on open (in case resize happened)
    applyResponsiveLayout(modal);
    loadItem();
  }

  function closeModal() {
    if (!modal) return;
    var video = document.getElementById('sfm-video');
    if (video) { video.pause(); video.src = ''; }
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function loadItem() {
    var item = items[currentIndex];
    var video = document.getElementById('sfm-video');
    var counter = document.getElementById('sfm-counter');
    var img = document.getElementById('sfm-img');
    var name = document.getElementById('sfm-name');
    var price = document.getElementById('sfm-price');
    var compare = document.getElementById('sfm-compare');
    var atc = document.getElementById('sfm-atc');

    video.src = item.videoSrc;
    video.play().catch(function(){});
    counter.textContent = (currentIndex + 1) + ' / ' + items.length;
    img.src = item.image || '';
    img.alt = item.name || '';
    name.textContent = item.name || '';
    price.textContent = item.price || '';

    if (item.comparePrice) {
      compare.textContent = item.comparePrice;
      compare.style.display = window.innerWidth <= 768 ? 'none' : 'block';
    } else {
      compare.style.display = 'none';
    }

    if (item.available === false) {
      atc.disabled = true;
      atc.textContent = 'Sold Out';
      atc.style.background = '#ccc';
      atc.style.color = '#888';
      atc.style.cursor = 'not-allowed';
      atc._variantId = null;
    } else {
      atc.disabled = false;
      atc.textContent = 'Add to Cart';
      atc.style.background = '#001f5b';
      atc.style.color = '#fff';
      atc.style.cursor = 'pointer';
      atc._variantId = item.variantId;
    }
  }

  function go(dir) {
    var video = document.getElementById('sfm-video');
    if (video) video.pause();
    currentIndex = (currentIndex + dir + items.length) % items.length;
    loadItem();
  }

  function addToCart() {
    var atc = document.getElementById('sfm-atc');
    if (!atc || !atc._variantId) return;
    var orig = atc.textContent;
    atc.textContent = 'Adding...';
    atc.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: atc._variantId, quantity: 1 })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      atc.textContent = 'Added ✓';
      setTimeout(function(){
        atc.textContent = orig;
        atc.disabled = false;
      }, 1500);
      // Update cart count
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        document.querySelectorAll('.cart-count-bubble span, [id*="cart-icon-bubble"] span').forEach(function(el){
          el.textContent = cart.item_count;
        });
      });
    })
    .catch(function(){
      atc.textContent = 'Error';
      atc.disabled = false;
      setTimeout(function(){ atc.textContent = orig; }, 1500);
    });
  }

  // Setup modal events after creation
  function setupModalEvents() {
    document.getElementById('sfm-overlay').addEventListener('click', closeModal);
    document.getElementById('sfm-close').addEventListener('click', closeModal);
    document.getElementById('sfm-prev').addEventListener('click', function(){ go(-1); });
    document.getElementById('sfm-next').addEventListener('click', function(){ go(1); });
    document.getElementById('sfm-atc').addEventListener('click', addToCart);
  }

  document.addEventListener('keydown', function(e){
    if (!modal || modal.style.display === 'none') return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowLeft') go(-1);
    if (e.key === 'ArrowRight') go(1);
  });

  // Init feed items
  function initFeed() {
    var cols = document.querySelectorAll('[data-section-name="shop-the-feed"] .shop-the-feed-items [class*="col-"]');
    var feedItems = [];

    cols.forEach(function(col) {
      var videoEl = col.querySelector('video source');
      var nameEl = col.querySelector('.stf-info-name');
      var imgEl = col.querySelector('.stf-thumb-img');
      var priceEl = col.querySelector('.stf-price-sale, .stf-price-regular');
      var compareEl = col.querySelector('.stf-price-compare');
      var soldOut = col.querySelector('.badge--sold_out');

      if (!videoEl) return;

      var item = {
        videoSrc: videoEl.getAttribute('src') || videoEl.src,
        name: nameEl ? nameEl.textContent.trim() : '',
        image: imgEl ? imgEl.src : '',
        price: priceEl ? priceEl.textContent.trim() : '',
        comparePrice: compareEl ? compareEl.textContent.trim() : '',
        available: !soldOut,
        variantId: null,
        productUrl: nameEl ? nameEl.getAttribute('href') : null
      };

      // Fetch variant id
      if (item.productUrl) {
        fetch(item.productUrl + '.js')
          .then(function(r){ return r.json(); })
          .then(function(p){
            item.variantId = p.variants[0].id;
            item.available = p.available;
          })
          .catch(function(){});
      }

      feedItems.push(item);

      col.style.cursor = 'pointer';
      col.addEventListener('click', function(e) {
        if (e.target.closest('.shop-the-feed__media-buttons__button')) return;
        if (e.target.closest('.stf-info-panel a')) return;

        // Create modal if not exists
        if (!modal) {
          modal = createModal();
          setupModalEvents();
        }

        var idx = feedItems.indexOf(item);
        openModal(feedItems, idx);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeed);
  } else {
    initFeed();
  }
})();
